/* eslint-disable */
export const protobufPackage = 'com.celertech.marketdata.api.enums.marketdatabooktype';

export enum MarketDataBookType {
    TOP_OF_THE_BOOK = 1,
    FULL_BOOK = 2,
    PRICE_LEVEL_BOOK = 3,
    UNRECOGNIZED = -1
}
